module.exports = __webpack_public_path__ + "media/images/soar/home_page_figure5-3a6d7c54fe87c33096a2636e97e12d19.png";